import React from 'react';
import {Text, StyleSheet, Platform, TextStyle} from 'react-native';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: TextStyle;
}

export function Icon({name, size = 24, color = '#000', style}: IconProps) {
  // Use Material Symbols font on all platforms
  // On web, the font is loaded via CSS
  // On native, the font is bundled in assets/fonts
  return (
    <Text
      maxFontSizeMultiplier={1}
      style={[
        styles.icon,
        {fontSize: size, color},
        style,
      ]}>
      {name}
    </Text>
  );
}

const styles = StyleSheet.create({
  icon: {
    // Font name must match the filename without extension on Android
    fontFamily: Platform.OS === 'web'
      ? 'Material Symbols Outlined'
      : 'MaterialSymbolsOutlined',
  },
});

export default Icon;
